<app-page-banner-item
  title="Наші люди"
  text="Що таке деменція, як поставити діагноз і як зменшити ризик розвитку деменції або відстрочити її вплив"
  [imgUrl]="'./assets/images/banner/our-people.png'"></app-page-banner-item>
<app-block-text *ngFor="let text of block" [text]="text"></app-block-text>
<div class="mb-30">
  <app-info-cards [cards]="cards"></app-info-cards>
</div>
<app-help-block [type]="'primary'"></app-help-block>
